module.exports = __webpack_public_path__ + "assets_1789888786567/img/guide_ios.431fc979.png";